import React from "react"
import css from "./AllDiseasesPage.scss"

// Simple skeleton div component to avoid grid issues
const SkeletonDiv = ({ width = "100%", height = "20px", className = "" }) => (
    <div
        className={className}
        style={{
            width,
            height,
            borderRadius: "4px",
            background: "#f6f7f8",
            backgroundImage: "linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "200vw 100vh",
            animation: "shimmer 1s linear infinite",
        }}
    />
)

export default function AllDiseasesSkeleton() {
    return (
        <>
            <style>{`
                @keyframes shimmer {
                    0% { background-position: -100vw 0; }
                    100% { background-position: 100vw 0; }
                }
            `}</style>

            <div className={`padding-16-0 ${css.pageContainer}`}>
                {/* Header Section */}
                <div className="padding-0-32">
                    <SkeletonDiv width="600px" height="24px" className="marginBottom-16" />
                </div>

                {/* Alphabet Chips Selector */}
                <div
                    className={`flex justifyCenter marginTop-16 padding-0-24 padding-8-0 textCenter flexWrap ${css.chipsContainer}`}
                >
                    <SkeletonDiv width="300px" height="40px" />
                </div>

                <div className="flexColumn padding-0-32">
                    {/* Results Count */}
                    <div className="padding-8-0 marginTop-16">
                        <SkeletonDiv width="150px" height="16px" />
                    </div>

                    {/* Disease Cards Grid */}
                    <div className={`flex marginTop-16 flexWrap justifyBetween ${css.diseasesContainer}`}>
                        {/* Generate 9 skeleton cards (3x3 grid) */}
                        {Array.from({ length: 9 }, (_, index) => (
                            <div key={index} className={`col-8 borderRadius ${css.cardContainer}`}>
                                <div className="padding-0-16 padding-16-0 flex alignCenter">
                                    {/* Disease Image Skeleton */}
                                    <SkeletonDiv width="50px" height="50px" />

                                    {/* Disease Content Skeleton */}
                                    <div
                                        className="marginLeft-auto flex flexColumn justifyCenter"
                                        style={{ flex: 1, overflow: "hidden", marginLeft: "16px" }}
                                    >
                                        <SkeletonDiv width="80%" height="18px" className="marginBottom-16" />
                                        <SkeletonDiv width="60%" height="14px" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Pagination */}
                    <div
                        className={`padding-16-0 flex alignCenter justifyCenter fullWidth ${css.paginationContainer}`}
                    >
                        <div className="flex alignCenter justifyCenter">
                            <SkeletonDiv width="120px" height="32px" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
